import { makeStyles } from '@material-ui/core';
import colors from './colors';

const contentStyles = makeStyles({
  icon: {
    color: colors.grayBlue[500],
    height: 22
  },
  success: {
    color: colors.success[500]
  },
  warning: {
    color: colors.warning[500]
  },
  error: {
    color: colors.error[500]
  }
});

export default contentStyles;
